module.exports = __webpack_public_path__ + "static/media/cookies.dc392a44.svg";